import { useCallback, useState } from 'react';

import { getDetailsByRoom, getRoomSelectionData } from '../../helpers';

const useEditFlow = ({ confirmAction, dataSource, modifyKey, setAction, setMenuVisible }) => {
  const [response, setResponse] = useState();
  const [room, setRoom] = useState();
  const [roomSelection, setRoomSelection] = useState(false);
  const [visible, setVisible] = useState(false);

  const getRoomSelectionState = useCallback(() => {
    const { details, modify: { [modifyKey]: { rooms = [] } = {} } = {} } = dataSource || {};
    const selectableRooms = getRoomSelectionData({ details, occupation: rooms });
    const totalRooms = getDetailsByRoom(details).length || selectableRooms.length;
    const hasPartialRoomSelection = totalRooms > 1 && selectableRooms.length < totalRooms;

    return {
      selectableRooms,
      showRoomSelection: selectableRooms.length > 1 || hasPartialRoomSelection,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSource?.details, modifyKey]);

  const open = useCallback(
    ({ fromConfirm = false, room: selectedRoom } = {}) => {
      const { selectableRooms, showRoomSelection: hasRoomSelection } = getRoomSelectionState();
      const showRoomSelection = !fromConfirm && hasRoomSelection;
      const resolved =
        selectedRoom ?? (!showRoomSelection && selectableRooms.length === 1 ? selectableRooms[0].room : undefined);

      setRoom(resolved);
      setRoomSelection(showRoomSelection);
      setVisible(!showRoomSelection);
    },
    [getRoomSelectionState],
  );

  const confirm = useCallback(
    (res) => {
      setResponse(res);
      setAction(confirmAction);
    },
    [confirmAction, setAction],
  );

  const close = useCallback(() => {
    setVisible(false);
    setRoom();
    setRoomSelection(false);
    setAction();
  }, [setAction]);

  const back = useCallback(() => {
    const { showRoomSelection } = getRoomSelectionState();

    setVisible(false);

    if (showRoomSelection) {
      setRoomSelection(true);
      return;
    }

    setRoomSelection(false);
    setMenuVisible(true);
  }, [getRoomSelectionState, setMenuVisible]);

  const backRoomSelection = useCallback(() => {
    setRoomSelection(false);
    setMenuVisible(true);
  }, [setMenuVisible]);

  const selectRoom = useCallback((selectedRoom) => {
    setRoom(selectedRoom);
    setRoomSelection(false);
    setVisible(true);
  }, []);

  const closeRoomSelection = useCallback(() => {
    setRoom();
    setRoomSelection(false);
    setAction();
  }, [setAction]);

  return {
    back,
    backRoomSelection,
    close,
    closeRoomSelection,
    confirm,
    open,
    response,
    room,
    roomSelection,
    selectRoom,
    visible,
  };
};

export { useEditFlow };
